var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contentContainer"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md8":"","lg4":""}},[_c('NotificationsCard',{attrs:{"user":_vm.user}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }